/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ChatSessionLink,
  ChatSessionLink$inboundSchema,
} from "./chatsessionlink.js";

export type ListSessionLinksResult = {
  /**
   * Links touching the requested chats, newest first.
   */
  links: Array<ChatSessionLink>;
};

/** @internal */
export const ListSessionLinksResult$inboundSchema: z.ZodMiniType<
  ListSessionLinksResult,
  unknown
> = z.object({
  links: z.array(ChatSessionLink$inboundSchema),
});

export function listSessionLinksResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSessionLinksResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSessionLinksResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSessionLinksResult' from JSON`,
  );
}
